import React from 'react';
import SvgGripDots from '@icons/grip-dots.svg?react';
import { PanelDock } from './usePanelDock.ts';

interface ComponentProps {
  dock: PanelDock;
}

/**
 * The "this can be dragged" sign for a dockable panel's header — a six-dot grip centred along the top
 * edge, where sheets and windows put their grab handle. Decoration only: the whole header is the
 * handle (dragHandleProps, which also makes the header its positioning context), the grip just says so.
 *
 * No tooltip: the grip is pressed to start a drag, and a tooltip anchored to it fights the panel as it
 * moves or swaps container. The grab cursor and the hover tint carry the hint instead.
 *
 * Renders nothing when the panel cannot float (switch off, not opted in, mobile), since then the header
 * cannot be dragged either.
 */
const PanelDragGrip: React.FC<ComponentProps> = ({ dock }) => {
  if (!dock.canFloat) return null;

  return (
    <span
      aria-hidden
      className="absolute left-1/2 top-1 inline-flex -translate-x-1/2 items-center text-content-tertiary transition-colors duration-200 group-hover/panel-header:text-content-brand"
    >
      <SvgGripDots className="h-4 w-4" />
    </span>
  );
};

export default PanelDragGrip;
